// Inline ResellerInfo to avoid circular dependency with resaleAuthorizations/reducer.ts
export type AWSPartnerTier = 'registered' | 'select' | 'advanced' | 'premier'

export interface ResellerInfo {
  resellerCompanyName?: string
  labraPlatformResellerId?: string
  geoLocation?: string
  resellerAwsAccountId?: string
  crmAwsResellerObjectId?: string
  awsPartnerTier?: AWSPartnerTier
}

export type KeyValue = {
  key: string
  value: string | boolean | number | ResellerInfo[] | null | undefined
}

export const initialPricesObject = {
  price1m: '',
  price12m: '',
  price24m: '',
  price36m: '',
  subscriptionPrice: '',
  additionalUsagePrice: '',
  price: '',
}
